import { useLocation } from "react-router-dom";

const blocksHomeNav = (pathname: string): boolean =>
    pathname.startsWith(`/signup/`);

export const useHeader = () => {
    const { pathname } = useLocation();
    return { navigateHome: !blocksHomeNav(pathname) };
};
